<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        AutoCoord Study Results
    </h2>
    <hr />
    <mat-dialog-content class="mat-typography">
        <app-grid-toolbar
            [gridApi]="gridApi"
            [options]="gridToolbarOptions"
        ></app-grid-toolbar>
        <ag-grid-angular
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            class="ag-theme-quartz h-[34rem] w-full"
        >
        </ag-grid-angular>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            mat-raised-button
            mat-dialog-close
            type="button"
            name="Close"
            cdkFocusInitial
            color="primary"
        >
            Close
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
